import Check from "./Check";
import Minus from "./Minus";
import Plus from "./Plus";
import BooksOnShelfColor from "./BooksOnShelfColor";
import BooksOnShelfStroke from "./BooksOnShelfStroke";
import ProjectPlaceholder from "./ProjectPlaceholder";
import MarginDecrease from "./MarginDecrease";
import MarginIncrease from "./MarginIncrease";

export default {
  CheckUnique: Check,
  MinusUnique: Minus,
  PlusUnique: Plus,
  BooksOnShelfColorUnique: BooksOnShelfColor,
  BooksOnShelfStrokeUnique: BooksOnShelfStroke,
  ProjectPlaceholderUnique: ProjectPlaceholder,
  MarginDecreaseUnique: MarginDecrease,
  MarginIncreaseUnique: MarginIncrease
};
